import axios from "axios";

const apiUrl = import.meta.env.VITE_API_URL + "brands";

export const dynamic = "force-dynamic";

export class BrandService {
  // Token handled by cookie

  // add a new brand
  async addBrand(brand) {
    try {
      const response = await axios.post(apiUrl, brand, {
        withCredentials: true
      });

      const data = response.data;
      if (!data.success) {
        throw new Error(data);
      }

      return data;
    } catch (error) {
      throw error;
    }
  }

  // get all brands
  async getBrands() {
    try {
      const response = await axios.get(apiUrl, {
        withCredentials: true
      });

      const data = response.data;
      if (!data.success) {
        throw new Error(data);
      }

      return data;
    } catch (error) {
      throw error;
    }
  }

  // get a single brand
  async getBrand(id) {
    try {
      const response = await axios.get(`${apiUrl}/${id}`, {
        withCredentials: true
      });

      const data = response.data;
      if (!data.success) {
        throw new Error(data);
      }

      return data;
    } catch (error) {
      throw error;
    }
  }

  // update a brand
  async updateBrand(brand) {
    try {
      const response = await axios.put(`${apiUrl}/${brand.id}`, brand, {
        withCredentials: true
      });
      const data = response.data;

      if (!data.success) {
        throw new Error(data);
      }

      return data;
    } catch (error) {
      throw error;
    }
  }

  // delete a brand
  async deleteBrand(id) {
    try {
      const response = await axios.delete(`${apiUrl}/${id}`, {
        withCredentials: true
      });
      const data = response.data;

      if (!data.success) {
        throw new Error(data);
      }

      return data;
    } catch (error) {
      throw error;
    }
  }
}
